import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import SCheckbox from 'SharedComponents/ui/Checkbox/SCheckbox.vue';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BooleanParameter' },
  __name: 'Boolean',
  props: {
    modelValue: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;

const { innerValue, emitValue } = useValue(props, emit);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SCheckbox, {
    modelValue: _unref(innerValue),
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
      _unref(emitValue)
    ],
    disabled: _ctx.$attrs.readonly
  }, null, 8, ["modelValue", "disabled", "onUpdate:modelValue"]))
}
}

})